import { ref, reactive, computed, watch } from 'vue'
import { client, activity, clearUser } from '@/controlles/client'
import { notSet,loading } from '@/controlles/general'
import axios from '@/utils/axios'
import { user, role, sklad1c } from '@/controlles/auth'
import { prototypeItem } from '@/controlles/basket/itemPrototype'

const basket = reactive([])
const viewbasket = ref(false)
const order = reactive({
  nextorder: [],
  activity: false,
  markingorder: false,
  producttotal: computed(() => {
    let price = 0
    order.nextorder = []
    order.markingorder = false
    for (const one of basket) {
      price = price + one.price * one.quantity
      order.nextorder.push(one.nextorder)
      if (one.marking) { order.markingorder = true }
    }
    return price
  }),
  typepayment: 'bank-card',
  paymentorder: {
    payment: computed(() => {
      let price = 0
      for (const one of basket) {
        price = price + one.price * one.quantity
      }
      if(['club-owner','club-manager'].includes(role.value) && sklad1c.value == '2-Готовая продукция'){
        return price - order.avanse - order.ad_deposit + user.value.armpoint.delivery.costprice  
      }
      return price - order.avanse - order.ad_deposit
    }),
    type: [
       { type: 'bank-card', activity: false, price: 0, entity: 'ivanytina', name: 'Оплата картой (Иванютина)' },
       { type: 'cash', activity: false, price: 0, entity: 'ivanytina', name: 'Оплата наличными' }
     /* { type: 'bank-card', activity: false, price: 0, entity: 'podgornov', name: 'Оплата картой (Терминал 1)' },
      { type: 'cash', activity: false, price: 0, entity: 'podgornov', name: 'Оплата наличными' },
      { type: 'bank-card', activity: false, price: 0, entity: 'damanina', name: 'Оплата картой (Терминал 2)' },
      { type: 'cash', activity: false, price: 0, entity: 'damanina', name: 'Оплата наличными' } */
    ],
    paymentFull: 0
  },
  bonus: 0,
  avanse: 0,
  ad_deposit: 0,
  refferal: null,
  promocodename: null,
  promocode: null,
  methodcrm: null,
  comments: null,
  pereezd:false,
  nextordergo: computed(() => {
    if(sklad1c.value == '2-Готовая продукция'){
      return true
    }  
    for (const one of order.nextorder) {
      if (!one) { return false }
    }
    return true
  }),
  dimensions:computed(() => {
            var length = 0
            var width = 0
            var height = 0
            var weight = 0
            var obem = 0
            for(let one of basket){
                length = length + one.dataproduct.model.dimensions.length*one.quantity / 1000|| 100
                width = width + one.dataproduct.model.dimensions.width*one.quantity / 1000 || 100
                height = height + one.dataproduct.model.dimensions.height*one.quantity / 1000 || 100
                weight = weight + one.dataproduct.model.dimensions.weight*one.quantity || 100

                var lo = (one.dataproduct.model.dimensions.length / 1000) || 100
                var wo = (one.dataproduct.model.dimensions.width / 1000)  || 100
                var ho = (one.dataproduct.model.dimensions.height / 1000) || 100

                obem = obem + (lo * wo * ho)*one.quantity 
            }
            
 			obem = obem + ((obem/100)*10)
 			var x = obem
 			x = Math.cbrt(x)
            
            return {
                length:Math.round(Math.ceil(x*1000)),
                width:Math.round(Math.ceil(x*1000)),
                height:Math.round(Math.ceil(x*1000)),
                weight:weight,
            }
        })
})

const timeout = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}

const razdelProduct = async (ind) => {
  const viewProduct = basket[ind]
  const n = viewProduct.quantity
  deleteProduct(ind)
  for (let i = 0; i < n; i++) {
    await timeout(1000)
    if (viewProduct.specification !== null) {
      var pr = new prototypeItem(viewProduct.productid, viewProduct.activityspecifications, viewProduct.dataproduct, viewProduct.specification)
      pr.addToCard()
    } else {
      var pr = new prototypeItem(viewProduct.productid, viewProduct.activityspecifications, viewProduct.dataproduct)
      pr.addToCard()
    }
  
  }
}

watch(order.paymentorder.type, (val) => {
  for (const one of order.paymentorder.type) {
    if (one.price > 0) {
      one.activity = true
      if (one.price < 0) {
        one.price = 0
      }
    } else { one.activity = false }
  }
})

const removePayment = () => {
  for (const one of order.paymentorder.type) {
    one.activity = false
    one.price = 0
  }
}

const addBasket = (product) => {
  if (!['club-owner','club-manager'].includes(role.value)) {
    if(sklad1c.value !== '2-Готовая продукция')
    if (!activity.value) {
      notSet('Авторизуйте клиента')
      return
    }


  }
  
  
  const basketProduct = new prototypeItem(
    product.productid.value,
    product.activityspecifications.value,
    product.dataproduct,
    product.specification.value,  
    product.quantity.value       
  )
  
  basketProduct.timeadd = new Date().getTime()
  basketProduct.promocodename.value = product.promocodename.value
  basketProduct.promocodesale.value = product.promocodesale.value
  
  basket.push(basketProduct)
}

const deleteProduct = (i) => {
  basket.splice(i, 1)
}

const deleteBasket = () => {
  basket.splice(0)
  order.refferal = null
  order.promocodename = null
  order.promocode = null
  order.pereezd = false
}

const changeBonus = (bonus) => {
 
  if (bonus == 0) {
    for (const one of basket) {
      one.remove_bonus = 0
    }
  } else {
    let allprice = 0
    const onepricent = Number(bonus) / 100
    for (const one of basket) { 
      if (one.dataproduct?.model?.checkagent == null) {
         allprice = allprice + one.price * one.quantity 
      }  
    }

    for (const one of basket) {
      if (one.dataproduct?.model?.checkagent == null) {
        const procent = (one.price / allprice) * 100
        const summa = Math.round(onepricent * procent)
        one.remove_bonus = summa
      }

    }
  }
  order.bonus = bonus
}

const changeAvanse = (avanse) => {
  order.avanse = avanse
}

const changeDeposit = (deposit) => {
  order.ad_deposit = deposit
}

const clearFishki = () => {
  changeBonus(0)
  changeDeposit(0)
  changeAvanse(0)
}

const sendNewOrder = async (channe = 'ultimatum-shop') => {
  try {
    const items = []

    var stItems = 'successfully'
     if (['club-owner','junior-manager','club-manager'].includes(role.value)) {
        if(sklad1c.value == '2-Готовая продукция'){
          stItems = 'new'
        }
     }
    for (const one of basket) {
      const as = one.activityspecifications
      const ms = {
        productid: one.productid,
        specification: as ? one.specification : null,
        guid: !as ? one.dataproduct.guid : `${one.dataproduct.guid}#${one.dataproduct.specifications.find(x => x._id == one.specification).guid}`,
        name: !as ? one.name : `${one.name} ${one.dataproduct.specifications.find(x => x._id == one.specification).name}`,
        realprice: one.realprice,
        price: one.price,
        discounts: {
          discount_activity: one.discount_activity,
          discount_type: null,
          discount_promocode: null,
          discount_procent: one.discount_procent,
          discount_sum: one.discount_sum
        },
        cashback: {
          remove_bonus: one.remove_bonus,
          remove_bonus_status: one.remove_bonus_status,
          add_bonus: 0,
          add_bonus_status: false
        },
        quantity: one.quantity,
        marking: one.marking,
        actual_delivery_cost: 0,
        customer_delivery_cost: 0,
        payment_status: 'not-paid',
        status:stItems
      }

      if (one.marking) {
        ms.marking_code = one.marking_code
        ms.marking_code_decode = one.marking_code_decode
        ms.marking_uuid = one.marking_uuid
      }
      if(one.changeprice && one.changeprice !== null){
        ms.changeprice = one.changeprice
      }

      items.push(ms)
    }
    const data = {
      channel: channe,
      items: items,
      bonus: order.bonus,
      manager: user.value._id,
      promocodename: order.promocodename,
      promocode: order.promocode,
      warehouse: 'shop',
      comments: order.comments,
      methodcrm: order.methodcrm,
      pereezd:order.pereezd
    }
    if (activity.value) {
      data.contragent = client.value._id
    } else {
      data.contragent = '62fd6ad64886f195911e7395'
    }
    var manAgs = null
    if(order.pereezd){
       if(['junior-manager'].includes(role.value)){
           data.contragent = '63f4b24585acab02a13295fd'
       }else{
          data.contragent = user.value.armpoint.refferal || null
       }
    }

    if (['club-owner','junior-manager','club-manager'].includes(role.value)) {
      if(sklad1c.value == '2-Готовая продукция'){
        data.warehouse = 'osnovnoi'
        data['clubonline'] = true

      }else{
        data.warehouse = user.value.armpoint.warehouses
      }
      data['club'] = user.value.armpoint._id
    }
    if (order.refferal !== null) {
      if (order.refferal !== data.contragent) {
        data.refferal = order.refferal
      }
    }
    const orderNew = await axios.post('https://api.ultimatum.store/order/addnew', data)
    return {
      orderID: orderNew._id,
      orderNumber: orderNew.ordernumber
    }
  } catch (e) { console.log(e) }
}


const createDeliveryClub = async (orderID,orderNumber) => {
  try {
    

    var product = []
    var dostavka = user.value.armpoint.delivery
    if(['junior-manager'].includes(role.value)){

      user.value.armpoint.refferal = '63f4b24585acab02a13295fd'
    }
    var userReff = await axios.post('https://api.ultimatum.store/bd/',{
      collection:'client',
      filter:{_id:user.value.armpoint.refferal},
      ignore:{phone:1,firstname:1,lastname:1}
    })

    var userRe = userReff.data[0]

     for (let one of basket){
            var as = one.activityspecifications
            product.push({
                name:one.name,
                id:one.productid,
                specification:one.specification,
                quantity:one.quantity,
                price:one.price,
                guid:!as ? one.dataproduct.guid : `${one.dataproduct.guid}#${one.dataproduct.specifications.find(x => x._id == one.specification).guid}`,
                tnved:one.dataproduct.tnved,
                artikul:!as ? one.dataproduct.artikul : one.dataproduct.specifications.find(x => x._id == one.specification).artikul,
                weight:one.dataproduct.model.dimensions.weight || 100
            })
       }

    
    var types = 'pickup-point'
    if(dostavka.service == 'couier'){
        
        types = 'door'
        
    }

    const dos = {
      delivery: {
        adress: dostavka.adress.fulladress,
        type: types,
        code: dostavka.code,
        activity: false,
        price: dostavka.costprice,
        costprice: dostavka.costprice,
        service: dostavka.service,
      },
      client: {
        name: `${userRe.firstname} ${userRe.lastname}`,
        phone: userRe.phone
      },
      payment:{
        oplata:false
      },
      items:{
                weight:order.dimensions.weight,
                height:order.dimensions.height,
                width:order.dimensions.width,
                length:order.dimensions.length,
                item:product
      },
      o:orderID,
      on:orderNumber
    }

    if(order.pereezd){
      dos['payment']['oplata'] = true
    }

    if(dostavka.service == 'couier'){
      dos.delivery.costprice = dostavka.costprice,
      dos.delivery.price = dostavka.price
    }
    const crea = await axios.post('https://api.ultimatum.store/delivery/createdocument', dos)
   
    return true
  } catch (e) { console.log(e) }
}

const createPayment = async (orderID, orderNumber, sd = 0, type = false, payment = 'bank-card') => {
  try {
    //var enTi = 'podgornov'
    var enTi = 'ivanytina'
    let typeSh = 'shop'
    //if (order.markingorder) { var enTi = 'damanina' }

    if (type) {
      enTi = 'ivanytina'
      typeSh = 'online'
      let status = 'not-paid'
      if (payment == 'cash') {
        status = 'paid'; 
        //enTi = 'damanina'
      }
      const data = {
        orderNumber: orderID,
        type: 'online',
        data: {
          service: payment,
          price: order.paymentorder.payment,
          status: status,
          type: 'in',
          client: client.value._id,
          entity: enTi
        }
      }
      const paymentId = await axios.post('https://api.ultimatum.store/payment/createpayment', data)
      await axios.post('https://api.ultimatum.store/order/updateOrderInfo', ['payment', orderID, paymentId._id])
      if (payment == 'moneta' && ['club-owner','club-manager'].includes(role.value)) {
        return paymentId
      }
    } else {
      const vyboroplaty = order.paymentorder.type.filter(x => x.activity == true)
      if (vyboroplaty.length > 0) {
        for (const one of vyboroplaty) {
          const data = {
            orderNumber: orderID,
            type: 'shop',
            data: {
              service: one.type,
              price: one.price - sd,
              status: 'paid',
              type: 'in',
              client: client.value._id,
              entity: one.entity
            }
          }
          const paymentId = await axios.post('https://api.ultimatum.store/payment/createpayment', data)
          await axios.post('https://api.ultimatum.store/order/updateOrderInfo', ['payment', orderID, paymentId._id])
        }
      }
    }
    if (order.avanse !== 0) {
      const datas = {
        orderNumber: orderID,
        type: typeSh,
        data: {
          service: 'return-advance',
          price: order.avanse,
          status: 'paid',
          type: 'in',
          client: client.value._id,
          entity: enTi
        }
      }

      const paymentIdAvanse = await axios.post('https://api.ultimatum.store/payment/createpayment', datas)
      await axios.post('https://api.ultimatum.store/order/updateOrderInfo', ['payment', orderID, paymentIdAvanse._id])
    }

    if (order.ad_deposit !== 0) {
      const datas = {
        orderNumber: orderID,
        type: typeSh,
        data: {
          service: 'endorsement-deposit',
          price: order.ad_deposit,
          status: 'paid',
          type: 'in',
          client: client.value._id,
          entity: enTi
        }
      }
      const paymentIdAdDeposit = await axios.post('https://api.ultimatum.store/payment/createpayment', datas)
      await axios.post('https://api.ultimatum.store/order/updateOrderInfo', ['payment', orderID, paymentIdAdDeposit._id])
    }
  } catch (e) { console.log(e) }
}


const promocodeUse = async (data) => {
  
  

  for (const one of basket) {
    if(one.dataproduct?.model?.checkagent == null) {
  
      if(data.tmppromocode.model.length > 0){
        if(data.tmppromocode.model.includes(one.dataproduct.model._id)){
          one.changePromocode(data)
        }
      }else{
        one.changePromocode(data)
      }
    }
  }
  order.promocode = data._id
  order.promocodename = data.name
}

const forceUpdate = async () => {
  try {
    loading.value = true;
    const newBasket = [];
    
    for (let one of basket) {
      await timeout(100);
      
      let pr;
      if (one.specification !== null) {
        pr = new prototypeItem(one.productid, one.activityspecifications, one.dataproduct, one.specification);
      } else {
        pr = new prototypeItem(one.productid, one.activityspecifications, one.dataproduct);
      }
      pr.quantity = one.quantity
      newBasket.push(pr);
    }
    basket.splice(0, basket.length, ...newBasket);
    loading.value = false;
  } catch(e) {
    loading.value = false;
    console.log('Error in forceUpdate:', e);
  }
};

const createDelivery = async (orderID) => {
  try {
    const dos = {
      delivery: {
        adress: '198330, Ананьевский пер., 5, стр. 9, Москва',
        time: 'пн-вс: 10.00-20.00',
        type: 'pickup-point',
        coords: [
          '55.77146577304853',
          '37.63454518651547'
        ],
        code: '107045',
        activity: false,
        price: 0,
        costprice: 0,
        day: 1,
        payment: null,
        service: 'shop',
        track: '0'
      },
      client: {
        name: `${client.value.firstname} ${client.value.lastname}`,
        phone: client.value.phone
      }
    }

    const crea = await axios.post('https://api.ultimatum.store/delivery/createdocument', dos)
    await axios.post('https://api.ultimatum.store/order/updateOrderInfo', ['delivery', orderID, crea.id])
    return true
  } catch (e) { console.log(e) }
}

const fishkiUser = () => {

  
  const bonus = computed(() => {
    if (!activity.value) return 0;
    const availableBonus = client.value.bonus || 0;
    const bonusLimitPercent = client.value?.limitbonus || 50;
    if (availableBonus === 0) return 0;
    var productProverka = 0

    for(let one of basket){
      if (one.dataproduct?.model?.checkagent == null) {
        productProverka = productProverka + one.price*one.quantity
      }
    }
  
    const maxBonusAmount = (productProverka * bonusLimitPercent) / 100;
    const availableForPayment = productProverka - order.avanse;

    if (availableForPayment <= 0) return 0;
    const bonusToUse = Math.min(
        availableBonus,
        maxBonusAmount,
        availableForPayment
    );
    
    return Math.round(bonusToUse);
});
  
  


  const avans = computed(() => {
    if (!activity.value) { return 0 }
    const b = client.value.avans ? client.value.avans : 0
    if (b !== 0) {
      if (b > order.producttotal) { return order.producttotal }
    }
    return b
  })

  const ad_deposit = computed(() => {
    if (!activity.value) { return 0 }
    const b = client.value.ad_deposit ? client.value.ad_deposit : 0
    if (b !== 0) {
      if (b > order.producttotal) { return order.producttotal }
    }
    return b
  })

  watch(viewbasket, () => {
    if (viewbasket.value) {
      let i = 0
      for (const one of basket) {
        const x = new prototypeItem(one.productid, one.activityspecifications, one.dataproduct, one.specification, one.quantity)
        deleteProduct(i)
        x.addToCard()
        i++
      }
    }
  })

  return {
    bonus,
    avans,
    ad_deposit
  }
}

export {
  basket,
  order,
  changeBonus,
  addBasket,
  deleteProduct,
  sendNewOrder,
  createPayment,
  deleteBasket,
  changeAvanse,
  changeDeposit,
  fishkiUser,
  viewbasket,
  removePayment,
  clearFishki,
  createDelivery,
  promocodeUse,
  razdelProduct,
  forceUpdate,
  createDeliveryClub
}
